import { injectEntityList } from '../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../common/store/base/injectPrimitive';
import { ISSOEntityModel } from '../../../../../service/sso/interface/ISSOEntityModel';
import { ISSOFormErrors, ISSOFormState, ISSOUI, SSOFormMode } from './ISSOUI';

export class SSOUI implements ISSOUI {
  constructor(
    public providersList = injectEntityList<ISSOEntityModel>([]),
    public isFormOpened = injectPrimitive<boolean>(false),
    public formMode = injectPrimitive<SSOFormMode>('create'),
    public editingProviderId = injectPrimitive<string | null>(null),
    public selectedProvider = injectPrimitive<ISSOEntityModel | null>(null),
    public isLoading = injectPrimitive<boolean>(false),
    public form = injectPrimitive<ISSOFormState>({
      name: '',
      clientId: '',
      clientSecret: '',
      issuer: '',
    }),
    public formErrors = injectPrimitive<ISSOFormErrors>({}),
    public isDeleteConfirmOpened = injectPrimitive<boolean>(false),
    public deletingProvider = injectPrimitive<ISSOEntityModel | null>(null),
  ) {}
}
